import { createIconComponent } from '../../factory/create-icon-component';
export const MoroccoIcon = createIconComponent(
  'MoroccoIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10086_33561)">
      <path d="M1 5V12.5V20H23V12.5V5H1Z" fill="#D80027" />
      <path
        d="M16.125 11.2039H12.9754L12 8.13708L11.0246 11.1995H7.875L10.423 13.0931L9.44766 16.1555L11.9957 14.2619L14.5438 16.1555L13.5684 13.0931L16.125 11.2039ZM11.1363 12.8603L11.4672 11.8234H12.5328L12.8637 12.8603L12 13.5018L11.1363 12.8603ZM12.3352 11.2039H11.6648L12 10.1494L12.3352 11.2039ZM13.3793 12.478L13.173 11.8234H14.2602L13.3793 12.478ZM10.827 11.8234L10.6207 12.478L9.74414 11.8234H10.827ZM10.6035 14.5387L10.9387 13.4842L11.4801 13.8884L10.6035 14.5387ZM12.5156 13.884L13.057 13.4798L13.3922 14.5343L12.5156 13.884Z"
        fill="#6DA544"
      />
    </g>
    <defs>
      <clipPath id="clip0_10086_33561">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
